import React, { useState, useEffect } from "react";
import axios from "axios";
import Paging from "./Paging";
import {Link} from "react-router-dom";
function Movies() {
  const [movies, setMovies] = useState([])
  const [pageNumber, setPage] = useState(1)
  const [hover, setHover] = useState()
  const [favourites, setfavourites] = useState([])
  // const [detail,setdetail] =useState([])

  function gonext() {
    setPage(pageNumber + 1);
  }
  function goback() {
    if (pageNumber > 1) {
      setPage(pageNumber - 1);
    }
  }
  

  useEffect(function () {
    
   let oldFav=localStorage.getItem("moviemania");
          oldFav=JSON.parse(oldFav)||[]; //changed at 2.02.48
          console.log(oldFav);
          setfavourites(oldFav)//changed at 1.54.20 and at 2.0.0
       

      axios.get(`https://api.themoviedb.org/3/trending/movie/week?api_key=1bd4fe515239128395e5f867d3913dac&page=${pageNumber}`).then((res) => 
         { console.table(res.data.results)
          setMovies(res.data.results)
          
         }
      );
    },
    [pageNumber]
  )

  let add = (movie) => {
    let newArray = [...favourites,movie]
    setfavourites([...newArray])
    console.log(newArray)
    localStorage.setItem("moviemania",JSON.stringify(newArray))
  }
    
  
  let del=(movie)=>{
    let newArray =favourites.filter((m)=>m.id!=movie.id)
    setfavourites([...newArray])
    localStorage.setItem("moviemania",JSON.stringify(newArray))
  }
  
  // let detailadd =(movie)=>{
  //   let detarray =[movie]
  //   setdetail([movie])
  //   localStorage.setItem("singleMovie",JSON.stringify(detarray))
  //   console.log([detarray])
  // }
  return (
    <div className="py-8 bg-yellow-300">
      <div className="flex mt-8 mb-8 font-bold md:text-5xl text-2xl text-center justify-center">
        Trending Movies &nbsp; 
        <img src="https://img.icons8.com/ios-filled/50/000000/movie-projector.png" className=""/>

  
      </div>
    
      <div className="flex flex-wrap justify-center">
        {movies.map((movie) => (
          <div to="/Detail"
            className={`bg-[url(https://image.tmdb.org/t/p/w500/${movie.backdrop_path})]
     h-[25vh] md:h-[30vh] w-[150px] md:w-[250px] bg-center bg-cover
      flex items-end rounded-xl m-4 hover:scale-110
      ease-out duration-300 relative
    `}
            onMouseEnter={() => {setHover(movie.id)
                   console.log(movie.id)}}
            onMouseLeave={() => setHover("")}
            // onClick={()=>detailadd(movie)}
          >
          {
            hover==movie.id &&<>{
              !favourites.find((m)=>m.id==movie.id) ?
               <div className="absolute top-2 right-2 p-2 bg-gray-800 text-xl rounded-xl cursor-pointer"
              onClick={()=>add(movie)}
              >💗</div>:
                <div className="absolute top-2 right-2 p-2 bg-gray-800 text-xl rounded-xl cursor-pointer"
              onClick={()=>del(movie)}
              >❌</div>
            }
              </>
          }
             
            

            <div className="w-full bg-stone-700  font-bold opacity-80 text-white py-2 text-center rounded-b-xl">
              {movie.title}
            </div>
        
          </div>

        ))}
      </div> 
      <Paging pageprop={pageNumber} goBack={goback} goNext={gonext}/>
                </div>

  )
}     
export default Movies
